import { CookieModule as e, LoggerModule as o } from "@packages/common";
import { UserService as r } from "./main69.js";
const s = {
  name: "UserModule",
  modules: [e, o],
  providers: [r]
};
export {
  s as UserModule
};
